import { Component, ViewChild } from '@angular/core';
import { Nav, Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { ThemesPage, VoltioLandingPage, BillSummaryPage, ResidentRegisterPage, BillCreatePage,
  ResidentSummaryPage, LoginPage, SignupPage, LogoutPage, ProjectNumberGeneratorPage  } from '../pages/index';
import {ThemeService} from '../providers/theme-service';

@Component({
  templateUrl: 'app.html',
  providers: [ThemeService]
})

export class VoltioPlatformApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any = VoltioLandingPage;

  // Theme and slogans
  chosenTheme: string;
  chosenSlogan: string;
  chosenTitle: string;

  pages: Array<{title: string, component: any}>;

  constructor(public platform: Platform, public statusBar: StatusBar,
              public splashScreen: SplashScreen, private _theme: ThemeService) {

    this._theme.getTheme().subscribe(val => this.chosenTheme = val);

    console.log('Initialise with following theme: ' + this.chosenTheme
      + ', Name: ' + this._theme.getNameOfTheme()
    + ', Slogan: ' + this._theme.getSlogan()
    + ', Title: ' + this._theme.getTitle());

    this.initializeApp();

    this.pages = [
      { title: 'Home', component: VoltioLandingPage},
      { title: 'Log in', component: LoginPage},
      { title: 'Sign up', component: SignupPage},
      { title: 'Log out', component: LogoutPage},
      { title: 'List Residents', component: ResidentSummaryPage},
      { title: 'Register Resident', component: ResidentRegisterPage },
      { title: 'Bill Summary', component: BillSummaryPage },
      { title: 'Create Bill', component: BillCreatePage },
      { title: 'Create ProjectID', component: ProjectNumberGeneratorPage },
      { title: 'Choose Theme', component: ThemesPage },
    ];
  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page.component);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts